import { PersonNameColumnFragment } from "gql/graphql";
import { ReactNode } from "react";
import { Hidable, Value } from "@/shared/value";
import { PersonNameColumnView } from "../views/person-name-column-view";

export function PersonNameColumn({
  data,
  afterName,
  extra,
}: {
  data?: Hidable<PersonNameColumnFragment>;
  afterName?: ReactNode;
  extra?: ReactNode;
}) {
  return (
    <Value data={data}>
      {(person) => (
        <PersonNameColumnView
          data={person}
          afterName={afterName}
          extra={extra}
        />
      )}
    </Value>
  );
}
